import { NextPage } from 'next'
import Head from 'next/head'

import FlowTemplate from '~/components/templates/FlowTemplate'

const title = 'FLOW'

const subtitle = 'お申し込みまでの流れ'

const colorProps = [
  {
    color: '#06a0cf',
    number: 1,
    flow: 'お問い合わせ',
    title: 'メール・DMにてお問い合わせ',
    description:
      'HPの「無料相談のお申込はこちら」から、もしくは公式TwitterのDMからお気軽にお問い合わせください。',
  },
  {
    color: '#068fcf',
    number: 2,
    flow: 'ご連絡',
    title: '担当者よりご連絡',
    description:
      'いただいたご連絡先にご相談内容に応じて専門領域の担当者より一両日中にご連絡をさせていただきます。お急ぎの場合は、メール・お電話のみでお見積もりをさせていただくことも可能です。',
  },
  {
    color: '#167296',
    number: 3,
    flow: '初回面談',
    title: 'オンライン面談の実施',
    description:
      'お客様のご都合に合わせて、初回面談の日時を設定させていただきます。面談はZOOMやGoogle Meetなどオンラインミーティングツールで行います（30分〜1時間程度）。お客様のご要望やターゲット層などをヒアリングさせていただきます。',
  },
  {
    color: '#165c96',
    number: 4,
    flow: '提案',
    title: 'ご提案作成',
    description:
      '初回面談を通じてご教示いただいた情報を元に、貴社の課題を解決するご提案を作成いたします。',
  },
  {
    color: '#164d96',
    number: 5,
    flow: '契約',
    title: 'ご契約の締結',
    description:
      'ご提案の内容にご納得いただけましたら、契約手続きに進ませていただきます。お支払いの方法などにつきましてはあらためてお知らせいたします。',
  },
  {
    color: '#0e3296',
    number: 6,
    flow: '制作',
    title: 'プロジェクト進行',
    description: 'ご提案内容を基に、プロジェクトを進行させていただきます。',
  },
]

const flow: NextPage = () => {
  return (
    <>
      <Head>
        <title>依頼の流れ　| eduad</title>
        <meta
          name='description'
          content='eduad-エデュアド-は教育・スクール運営に特化したウェブマーケティング支援を行うプロフェッショナル技術者集団です。お問い合わせ〜ご契約までの流れをご紹介いたします。'
        />
      </Head>
      <FlowTemplate title={title} subtitle={subtitle} colorProps={colorProps} />
    </>
  )
}

export default flow
